import { Route, Switch, Redirect } from 'react-router-dom';
import { MARKETPLACE_HOMEPAGE_ROUTES } from '../config/routes';
import { useFeature } from 'lib/featureFlags/features';
import { useAzureFeatureFlags } from 'lib/featureFlags/azure-feature-flags';
import { LoadingScreen } from 'features/common/components/LoadingScreen';
import { getBaseMarketplaceAppUrl } from '../config/env';
import { fetchLastSuccessfulLoginOrganizationId } from '@sitecore-ui/portal-singular';
import { IframeWithNavigationSync } from 'features/common/components/IframeWithNavigationSync';

export const MarketplaceRoutes: React.FC = () => {
  const { isLoading } = useAzureFeatureFlags({ enabled: true });
  const featureEnabled = useFeature('MARKETPLACE');

  if (isLoading) {
    return <LoadingScreen data-testid='loading-component' message='Loading…' />;
  }

  if (!featureEnabled && !isLoading) {
    return <Redirect to='/no-access' />;
  }

  const organizationId = fetchLastSuccessfulLoginOrganizationId();
  const marketplaceAppUrl = getBaseMarketplaceAppUrl();
  const marketplaceHomepageUrl = `${marketplaceAppUrl}/?organization=${organizationId}`;

  return (
    <Route path={MARKETPLACE_HOMEPAGE_ROUTES.ROOT}>
      <Switch>
        <Route
          exact
          path={`${MARKETPLACE_HOMEPAGE_ROUTES.ROOT}`}
          render={() => (
            <IframeWithNavigationSync
              src={marketplaceHomepageUrl}
              title='Marketplace Homepage Iframe'
              debugMode={process.env.NODE_ENV === 'development'}
            />
          )}
        />
      </Switch>
    </Route>
  );
};
